<template>
  <div class="filter">
    <p class="filter-text">Ordenar por </p>
    <div class="filter-select-wrapper">
      <p class="filter-selected-option" @click="toggleShowFilters">
        {{ selectedFilter }}
      </p>
      <ul class="filter-option-list" v-if="showFilters">
        <li
          v-for="(filter, key) in filters"
          @click="setSelectedFilter(key)"
          class="filter-option">
          {{ filter }}
        </li>
      </ul>
    </div>
    <i
      class="icon fal"
      :class="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"
      @click="toggleShowFilters"
    ></i>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  const COMMENT_FILTERS = {
    relativeCommentIdDesc: 'Más recientes primero',
    relativeCommentIdAsc: 'Más antiguos primero',
    relevance: 'Relevancia'
  };

  export default {
    data() {
      return {
        filters: COMMENT_FILTERS,
        selectedFilter: null,
        showFilters: false,
      }
    },
    mounted() {
      this.selectedFilter = this.filters.relativeCommentIdDesc;
    },
    methods: {
      ...mapActions([
        'updateFilters',
        'fetchComments',
      ]),
      setSelectedFilter(f) {
        this.selectedFilter = COMMENT_FILTERS[f];
        this.showFilters = false;
        this.updateFilters({ orderBy: f, page: 1 });
      },
      toggleShowFilters() {
        this.showFilters = !this.showFilters;
      }
    },
  }
</script>
